module.exports = __webpack_public_path__ + "fdadcc61602c9bfd08d057ac98bd2a46.jpg";